import editImage from "../assets/images/edit.png";
import cancelImage from "../assets/images/cancel.png";
import { useState } from "react";
import { useDeleteTodoMutation, useUpdateColorMutation, useUpdateStatusMutation, useUpdateTodoMutation } from "../features/api/apiSlice";

export default function Todo({ todo }) {
    const [updateStatus] = useUpdateStatusMutation();
    const [updateColor] = useUpdateColorMutation();
    const [updateTodo] = useUpdateTodoMutation();
    const [deleteTodo] = useDeleteTodoMutation();
    const [showInputText, setShowInputText] = useState(false);
    
    const { text, id, completed, color } = todo;
    const [inputText, setInputText] = useState(text);

    const handleStatusChange = (todoId) => {
        updateStatus({id : todoId, currentStatus: completed});
    };

    const handleColorChange = (todoId, color) => {
        updateColor({ id: todoId, color});
    };

    const handleDelete = (todoId) => {
        deleteTodo(todoId);
    };

    const handleUpdate = () => {
        setShowInputText(true);
    };
    
    const handleUpdateText = (e) => {
        const todoText = e.target.value;
        setInputText(todoText);

        if (e.key === 'Enter' || e.keyCode === 13) {
            setShowInputText(false);
            updateTodo({ id, todoText});
        }
    };

    return (
        <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
            <div
                className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
                    completed &&
                    "border-green-500 focus-within:border-green-500"
                }`}
            >
                <input
                    type="checkbox"
                    checked={completed}
                    onChange={() => handleStatusChange(id)}
                    className="opacity-0 absolute rounded-full"
                />
                {completed && (
                    <svg
                        className="fill-current w-3 h-3 text-green-500 pointer-events-none"
                        viewBox="0 0 20 20"
                    >
                        <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                    </svg>
                )}
            </div>

            {!showInputText ?  
            <div
                className={`select-none flex-1 ${completed && "line-through"}`}
            >
                {inputText}
            </div> : 
              <>
                 <input
                    type="text"
                    defaultValue={inputText}
                    onKeyDown={handleUpdateText}
                    className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-50 text-gray-500"
                />
              </>       
            }

            <div
                className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${
                    color === "green" && "bg-green-500"
                }`}
                onClick={() => handleColorChange(id, "green")}
            ></div>

            <div
                className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
                    color === "yellow" && "bg-yellow-500"
                }`}
                onClick={() => handleColorChange(id, "yellow")}
            ></div>

            <div
                className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${
                    color === "red" && "bg-red-500"
                }`}
                onClick={() => handleColorChange(id, "red")}
            ></div>

            <img
                src={editImage}
                className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                alt="Edit"
                onClick={handleUpdate}
            />
            <img
                src={cancelImage}
                className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                alt="Cancel"
                onClick={() => handleDelete(id)}
            />
        </div>
    );
}
